module.exports = __webpack_public_path__ + "img/no-data2.b0a1fb95.png";